// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Member__container--oboV9"};